<template>
  <button id="backToTop">
    <img src="@/assets/01/tag_backtotop.svg" @click="btt()" d-none />
  </button>
</template>

<script>
export default {
  name: "BackToTopBtn",
  methods: {
    btt() {
      document.documentElement.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
  mounted() {
    let bttBTN = document.querySelector("#backToTop");
    bttBTN.style.display = "none";
    window.onscroll = () => {
      if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        bttBTN.style.display = "block";
      } else {
        bttBTN.style.display = "none";
      }
    };
  },
};
</script>

<style>
#backToTop {
  position: fixed;
  bottom: 90px;
  right: 30px;
  width: 50px;
  box-shadow: 0 0px 5px 0px grey;
  padding: 0;
  border: none;
  z-index: 8;
}
@media (max-width: 450px) {
  #backToTop {
    bottom: 70px;
    right: 20px;
    width: 40px;
  }
}
</style>
